import { CheckIcon, LockIcon, MinusIcon, TimerIcon, UserCheckIcon } from 'lucide-react';
import type { Permission } from '../../types/settings';

/** How each permission level reads in the matrix, in the order a tap cycles through them. */
export const PERMISSION_CYCLE: Permission[] = ['zelf', 'tenzijBezwaar', 'naOk', 'nooit', 'nvt'];

export const PERMISSION_META: Record<Permission, { short: string; icon: typeof CheckIcon; className: string }> = {
  zelf: { short: 'Zelf', icon: CheckIcon, className: 'bg-white/[0.06] text-ink-soft' },
  tenzijBezwaar: { short: 'Tenzij bezwaar', icon: TimerIcon, className: 'bg-accent/10 text-accent' },
  naOk: { short: 'Na ok', icon: UserCheckIcon, className: 'bg-ink text-night-950' },
  nooit: { short: 'Nooit', icon: LockIcon, className: 'border border-dashed border-white/20 text-ink-muted' },
  nvt: { short: '—', icon: MinusIcon, className: 'text-ink-muted/60' },
};
